import { ProjectYearlyCosts } from '../interfaces/projectYearlyCosts.interface';

const YEARS = 5; // Years 1–5

export const DEFAULT_PROJECT_YEARLY_COSTS: ProjectYearlyCosts = {
  software: Array(YEARS).fill(0),
  services: Array(YEARS).fill(0),
  partnerServices: Array(YEARS).fill(0),
  total: Array(YEARS).fill(0),
  ramp: [20, 30, 50, 100, 100],
  growthRate: 5,
  inflationRate: 3,
};

export const ZERO_PROJECT_YEARLY_COSTS: ProjectYearlyCosts = {
  software: Array(YEARS).fill(0),
  services: Array(YEARS).fill(0),
  partnerServices: Array(YEARS).fill(0),
  total: Array(YEARS).fill(0),
  ramp: [20, 30, 50, 100, 100],
  growthRate: 5,
  inflationRate: 3,
};

const ensureArray = (values?: number[]): number[] => {
  if (!Array.isArray(values)) return [];
  return values.map((value) => Number(value) || 0);
};

const padArray = (values: number[], length: number): number[] => {
  const normalized = values.slice(0, length);
  while (normalized.length < length) {
    normalized.push(0);
  }
  return normalized;
};

export const normalizeYearlyCosts = (
  input?: Partial<ProjectYearlyCosts> | null,
  fallback: ProjectYearlyCosts = DEFAULT_PROJECT_YEARLY_COSTS
): ProjectYearlyCosts => {
  const length = fallback.software.length || YEARS;
  const software = padArray(ensureArray(input?.software ?? fallback.software), length);
  const services = padArray(ensureArray(input?.services ?? fallback.services), length);
  const partnerServices = padArray(ensureArray((input as any)?.partnerServices ?? fallback.partnerServices), length);

  const total = Array.from({ length }, (_, idx) => software[idx] + services[idx] + partnerServices[idx]);

  const ramp = padArray(
    ensureArray(input?.ramp ?? fallback.ramp).map((v) => Math.max(0, Math.min(100, v))),
    length
  );

  const growthRate = Number(input?.growthRate ?? fallback.growthRate) || 0;
  const inflationRate = Number(input?.inflationRate ?? fallback.inflationRate) || 0;

  return {
    software,
    services,
    partnerServices,
    total,
    ramp,
    growthRate,
    inflationRate,
  };
};
